export const TODO_ITEM_TYPES = [
  {
    key: "PHARMACY_REFILL_ORDER",
    label: "Pharmacy Refill Order",
    description: "Follow up call to a patient two weeks after signup. Call should cover medication adherance, adverse reactions, and recommendations of best practices.",
    targetType: "pharmacy",
  },
  {
    key: "PATIENT_FOLLOW_UP",
    label: "Patient follow up",
    description: "Follow up call to a patient two weeks after signup. Call should cover medication adherance, adverse reactions, and recommendations of best practices.",
    targetType: "member",
  },
];

export const PRESCRIPTION_STATUS_OPTIONS = [
  { label: "New", value: "new" },
  { label: "Contact attempted 1", value: "contact_attempted" },
  { label: "Contact attempted 2", value: "contact_attempted_2" },
  { label: "Contact attempted 3", value: "contact_attempted_3" },
  { label: "Declined", value: "declined" },
  { label: "Accepted", value: "accepted" },
  { label: "Changed", value: "changed" },
  { label: "Patient hold", value: "on_hold" },
  { label: "Delayed entry", value: "delayed_entry" },
  { label: "Clarification", value: "clarify" },
  { label: "Refill", value: "refill" },
  { label: "Refill with change", value: "refill_with_change" },
  { label: "No contact", value: "no_contact" },
];

export const PLAN_STATUS_OPTIONS = [
  { label: "Active", value: "active" },
  { label: "Activated - Pending start", value: "activated - pending start" },
  { label: "Active - Payments complete", value: "active - payments complete" },
  { label: "Paused", value: "paused" },
  { label: "Cancelled", value: "cancelled" },
  { label: "Awaiting payment", value: "awaiting payment" },
  { label: "Failed payment", value: "failed payment" },
];

export const ROLE_OPTIONS = [
  { label: "Administrator", value: "business_administrator" },
  { label: "Management", value: "business_management" },
  { label: "Operations", value: "business_operations" },
  { label: "Predictile Administrator", value: "predictile_administrator" },
  { label: "Predictile Management", value: "predictile_management" },
  { label: "Predictile Operations", value: "predictile_operations" },
];

export const VIEWABLE_EXTENSIONS = ["docx", "pdf", "png", "jpeg", "jpg", "xlsx", "pptx"];

export const STATE_OPTIONS = [
  { value: "AL", name: "Alabama" },
  { value: "AK", name: "Alaska" },
  { value: "AZ", name: "Arizona" },
  { value: "AR", name: "Arkansas" },
  { value: "CA", name: "California" },
  { value: "CO", name: "Colorado" },
  { value: "CT", name: "Connecticut" },
  { value: "DE", name: "Delaware" },
  { value: "FL", name: "Florida" },
  { value: "GA", name: "Georgia" },
  { value: "HI", name: "Hawaii" },
  { value: "ID", name: "Idaho" },
  { value: "IL", name: "Illinois" },
  { value: "IN", name: "Indiana" },
  { value: "IA", name: "Iowa" },
  { value: "KS", name: "Kansas" },
  { value: "KY", name: "Kentucky" },
  { value: "LA", name: "Louisiana" },
  { value: "ME", name: "Maine" },
  { value: "MD", name: "Maryland" },
  { value: "MA", name: "Massachusetts" },
  { value: "MI", name: "Michigan" },
  { value: "MN", name: "Minnesota" },
  { value: "MS", name: "Mississippi" },
  { value: "MO", name: "Missouri" },
  { value: "MT", name: "Montana" },
  { value: "NE", name: "Nebraska" },
  { value: "NV", name: "Nevada" },
  { value: "NH", name: "New Hampshire" },
  { value: "NJ", name: "New Jersey" },
  { value: "NM", name: "New Mexico" },
  { value: "NY", name: "New York" },
  { value: "NC", name: "North Carolina" },
  { value: "ND", name: "North Dakota" },
  { value: "OH", name: "Ohio" },
  { value: "OK", name: "Oklahoma" },
  { value: "OR", name: "Oregon" },
  { value: "PA", name: "Pennsylvania" },
  { value: "RI", name: "Rhode Island" },
  { value: "SC", name: "South Carolina" },
  { value: "SD", name: "South Dakota" },
  { value: "TN", name: "Tennessee" },
  { value: "TX", name: "Texas" },
  { value: "UT", name: "Utah" },
  { value: "VT", name: "Vermont" },
  { value: "VA", name: "Virginia" },
  { value: "WA", name: "Washington" },
  { value: "WV", name: "West  Virginia" },
  { value: "WI", name: "Wisconsin" },
  { value: "WY", name: "Wyoming" },
];
